import { Badge } from '@parrot-software/design-system';
import { CircleAlert } from '@parrot-software/design-system/icons';

interface MissingDataBadgeProps {
  label: string;
}

/**
 * MissingDataBadge - Destructive (light) badge signalling missing required data.
 *
 * Matches the Figma "Sin datos fiscales, no se emitirá factura" badge: light red
 * background, destructive red text and a circle-alert icon. Reused across surfaces
 * for any missing-data state (e.g. no fiscal data, no payment method configured)
 * by passing the corresponding `label`.
 *
 * @param {Object} props - Component properties
 * @param {string} props.label - Badge text describing the missing data
 * @returns {React.ReactElement} Destructive light badge
 */
export const MissingDataBadge = ({ label }: MissingDataBadgeProps) => (
  <Badge className="w-fit bg-red-50 text-destructive hover:bg-red-50" variant="secondary">
    <CircleAlert className="w-3 h-3 mr-1 shrink-0" />
    {label}
  </Badge>
);
